import React from 'react';
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CreditCard } from "lucide-react";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";

const BuyCreditsCard = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/buy-credits");
    };

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Card
                        onClick={handleClick}
                        className="hover:bg-accent/5 transition-colors border-dashed bg-background/50 cursor-pointer"
                    >
                        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                            <CardTitle className="text-sm font-medium">
                                Buy Credits
                            </CardTitle>
                            <CreditCard className="h-4 w-4 text-muted-foreground" />
                        </CardHeader>
                        <CardContent>
                            <div className="text-2xl font-bold text-muted-foreground">
                                Get more
                            </div>
                        </CardContent>
                    </Card>
                </TooltipTrigger>
                <TooltipContent>
                    <p>Click to purchase additional credits</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default BuyCreditsCard;